import { HdBodygraphActivation, HdBodygraphCenter } from '../hd-bodygraph.models';

export type HdCenterInfoMode = 'compact' | 'full';

export interface HdCenterInfoRequestedContext {
  readonly kind: 'center-requested';
  readonly center: HdBodygraphCenter;
  readonly isDefined: boolean;
  /** Undefined center without any active gate. Always false for defined centers. */
  readonly isOpen: boolean;
  readonly activations: readonly HdBodygraphActivation[];
  /**
   * Gedefinieerde kanalen van dit center in de chart (render-state). Optioneel:
   * zonder chart-context blijft de golvenlijst van de Solar Plexus neutraal.
   */
  readonly definedChannelKeys?: readonly string[];
  readonly showBothStateSections?: boolean;
  readonly initialMode?: HdCenterInfoMode;
}

export function buildHdCenterInfoPanelKey(center: HdBodygraphCenter): string {
  return `center-info:${center}`;
}
